
import React from "react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";

interface ImageImportStatusProps {
  isProcessing: boolean;
  processedCount: number;
  totalCount: number;
  proxyError: string | null;
}

const ImageImportStatus: React.FC<ImageImportStatusProps> = ({
  isProcessing,
  processedCount,
  totalCount,
  proxyError
}) => {
  if (!isProcessing && !proxyError) return null;
  
  return (
    <>
      {proxyError && (
        <Alert variant="destructive" className="mb-4">
          <AlertTitle>Image Proxy Error</AlertTitle>
          <AlertDescription>
            {proxyError}
            <p className="mt-2 text-sm">
              We're having trouble accessing images from Bubble.io. This is likely due to CORS restrictions.
              Please try using direct image URLs from other sources.
            </p>
          </AlertDescription>
        </Alert>
      )}
      
      {isProcessing && (
        <div className="bg-blue-50 p-4 rounded-md">
          <p className="text-blue-700">
            Processing images: {processedCount} of {totalCount} complete
          </p>
        </div>
      )}
    </>
  );
};

export default ImageImportStatus;
